<template>
    <div class="brand-page">
        <div class="row no-gutters brands-hero2" id="Westcountygardener2">
            <div>
                <img src="/images/brand-bgs/brand-logo-bg.png" alt="background">
                <img src="/images/brand-logos/west-county-gloves.png" alt="west county logo">
            </div>
        </div>

        <div class="brand-content">
            <div>
                <p>
                    From planting seedlings, to laying a patio, or cleaning gutters, West County Gardener® has a glove for every season and task. 
                    Through an innovative combination of materials and construction techniques once found only in premium athletic apparel, we've created the world's first high performance gardening gloves for both weekend and professional gardeners and landscapers. 
                    Like all great tools, their design and functionality help you work with comfort and ease. Our gloves are known for their signature snug fit. 
                    We know every hand is different, and the 'one size fits all' model just doesn't cut it.  
                    We've developed a wide range of sizes in both men's and women's gardening gloves, ensuring the right fit and reducing the chance of injury to your hands while you work.
                </p>
                <p>  
                    Our goal is to design and engineer the best fitting high-performance gloves for your various needs. 
                    We listen to our customers and continually make small 'running changes' based on user feedback, enhancing each of our products to make your time outdoors more enjoyable, productive, and comfortable. 
                    With your help and our expertise, we make the best gloves you will ever wear! 
                </p>
                <a href="https://westcountygardener.com/" class="btn-round-black" target="_blank">westcountygardener.com</a>
            </div>
        </div>

        <div class="socialspace" style="background-color: #333;">
            <div>
                <div>
                    <h4>Follow Us</h4>
                    <div>
                        <a href="https://www.facebook.com/westcountygardener" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-facebook']"  />
                        </a>
                        <a href="https://www.instagram.com/westcountygardenergloves/" target="_blank">
                            <font-awesome-icon class="social-icon" :icon="['fab', 'square-instagram']" />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Contact Us</h4>
                    <div class="contact-container">            
                        <div>
                            <a href="mailto:sales@westcountygardener.com">
                                <font-awesome-icon :icon="['fass', 'envelope']" />
                            </a>                 
                            <a href="mailto:sales@westcountygardener.com">sales@westcountygardener.com</a>
                        </div>
                        <div>
                            <a href="tel:800-969-7562">
                                <font-awesome-icon :icon="['fass', 'phone']" />
                            </a>
                            <a href="tel:800-969-7562">(800) 969-7562</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4>Buy Now</h4>
                    <div>
                        <a href="https://www.amazon.com/stores/WestCountyGardener/page/88218223-C0C6-466A-946D-5CB66AD76C4B?ref_=ast_bln" target="_blank" aria-label='Link opens in new window (amazon.com/stores/WestCountyGardener)'>
                            <img id="amazon-logo" src="/images/amazon-logo-white.svg" alt="amazon logo">
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {};
    },
    methods: {
    }
};
</script>
